import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { TranslateDirective } from '../../../../directives/translate.directive';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';

import { OptionFilterPipe } from '../../../pipes/option-filter.pipe';

import { BaryComponentHelper } from '../../util/bary-component-helper';

@Component({
  selector: 'jhi-bary-input-select',
  templateUrl: './bary-input-select.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, TranslateDirective, MarkAsteriskDirective, OptionFilterPipe],
  styleUrls: ['./bary-input-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BaryInputSelectComponent implements OnInit {
  @Input() public id = '';
  @Input() public label = '';
  @Input() public hasFilter = false;
  @Input() public name?: string;
  @Input() public placeholder?: string;
  @Input() public disabled = false;
  @Input() public options!: Array<{ label: string; value: any }>;
  @Input() public optionsWithMdbIcons!: Array<{ label: string; value: any; mdbIcons: any }>;
  @Input() public withMdbIcons = false;
  @Input() public control = new FormControl('');

  @Output() public selectEvent = new EventEmitter();

  public selectControlFilter = new FormControl('');

  public ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    this.control.valueChanges.subscribe(val => this.selectEvent.emit(val));
  }
}
